import {EntityState} from '@reduxjs/toolkit';

export type TDraggableFramesSliceState = {
    draggableFrames: EntityState<IDraggableFrameEntity>;
    lastFrameId: number;
}

export enum EDraggableFrameType {
    TableReportAttachmentUploadFrame = 'TableReportAttachmentUploadFrame',
    ApiRequestProgressFrame = 'ApiRequestProgressFrame'
}

export interface IDraggableFrameEntity<T=any> {
    type: EDraggableFrameType;
    id?: number;
    isOpen?: boolean;
    data?: T;
}
